module.exports = __webpack_public_path__ + "static/jaime-21a2db943ccf2b9ae5adb734d5595911.webp";